import type { QNotifyCreateOptions } from 'quasar'
import { Notify, Dialog } from 'quasar'
import { i18n } from '../boot/i18n'

export const success = (i18nMessage?: string, dismissable = false) => {
  // Use the message directly as fallback for now
  // TODO: Implement proper i18n integration when needed
  const message = i18nMessage || 'Success'
  const notificationOptions: QNotifyCreateOptions = {
    message,
    position: 'top',
    color: 'positive',
  }

  if (dismissable) {
    notificationOptions.timeout = 0
    notificationOptions.actions = [{ label: 'Dismiss', color: 'white' }]
    notificationOptions.html = true
  }

  Notify.create(notificationOptions)
}

type FluentError = {
  message: string
  errors: { errorCode: string; errorMessage: string; propertyName: string }[]
}
export const fail = (i18nMessage?: string | FluentError, timeout = 10000) => {
  // Use the message directly as fallback for now
  let displayMessage =
    typeof i18nMessage === 'string' ? i18n.global.t(i18nMessage) : 'Error'
  if (typeof i18nMessage === 'object') {
    if ('message' in i18nMessage) {
      displayMessage = i18n.global.t(i18nMessage.message)
    }
    if ('errors' in i18nMessage && i18nMessage.errors.length > 0) {
      displayMessage = i18nMessage.errors
        .map((e) => i18n.global.t(e.errorMessage))
        .join('<br/>')
    }
  }
  Notify.create({
    message: displayMessage,
    timeout,
    color: 'negative',
    icon: 'info',
    html: true,
    position: 'top',
  })
}

export interface IConfirmOptions {
  title?: string
  message?: string
  cancel?: boolean
  persistent?: boolean
  okHandler?: () => void
  cancelHandler?: () => void
}

export const confirm = (options: IConfirmOptions) => {
  const {
    title,
    message,
    okHandler,
    cancelHandler,
    cancel = true,
    persistent = false,
  } = options
  Dialog.create({
    title: title || 'Alert',
    message: message || '',
    cancel: cancel,
    persistent,
    html: true,
  })
    .onOk(() => {
      okHandler?.()
    })
    .onCancel(() => {
      cancelHandler?.()
    })
}
